import React from 'react';

export const AgentCardSkeleton: React.FC = () => {
    return (
        <div className="h-[272px] flex flex-col border border-[#F0F0F0] dark:border-[#3A3C40] rounded-[16px] p-4 animate-pulse">
            {/* Header */}
            <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                    <div className="w-9 h-9 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse" />
                    <div className="h-5 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
                </div>
                <div className="w-6 h-6 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
            </div>

            {/* Role */}
            <div className="h-4 w-20 bg-gray-200 dark:bg-gray-700 rounded animate-pulse mb-4" />

            {/* Info sections */}
            <div className="space-y-3 mb-4">
                <div className="flex items-center justify-between">
                    <div className="h-4 w-12 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
                    <div className="h-4 w-16 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
                </div>
                <div className="flex items-center justify-between">
                    <div className="h-4 w-16 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
                    <div className="h-4 w-20 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
                </div>
            </div>

            {/* Buttons */}
            <div className="mt-auto flex items-center gap-2">
                <div className="w-[162px] h-[38px] bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
                <div className="flex-1 flex items-center gap-2">
                    <div className="flex-1 h-[38px] bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
                    <div className="flex-1 h-[38px] bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
                </div>
            </div>
        </div>
    );
};
